import React from "react";
import { Carousel } from "react-bootstrap";
import "./FeaturedProductsCarousel.css";

// Imágenes de productos
import product1 from "../assets/product1.png";
import product2 from "../assets/product2.png";
import product3 from "../assets/product3.png";
import product4 from "../assets/product4.png";
import product5 from "../assets/product5.png";
import product6 from "../assets/product6.png";

const FeaturedProductsCarousel = () => {
  const products = [
    { id: 1, name: "Producto 1", description: "Descripción breve 1", image: product1 },
    { id: 2, name: "Producto 2", description: "Descripción breve 2", image: product2 },
    { id: 3, name: "Producto 3", description: "Descripción breve 3", image: product3 },
    { id: 4, name: "Producto 4", description: "Descripción breve 4", image: product4 },
    { id: 5, name: "Producto 5", description: "Descripción breve 5", image: product5 },
    { id: 6, name: "Producto 6", description: "Descripción breve 6", image: product6 },
  ];

  const pages = [];
  for (let i = 0; i < products.length; i += 3) {
    pages.push(products.slice(i, i + 3)); // 3 productos por página
  }

  return (
    <div className="featured-products-container">
      <div className="featured-products-section py-5">
        <h2 className="text-center mb-5">Productos Destacados</h2>
        <Carousel className="featured-products-carousel">
          {pages.map((page, pageIndex) => (
            <Carousel.Item key={pageIndex}>
              <div className="d-flex justify-content-center gap-4 flex-wrap">
                {page.map((product) => (
                  <div key={product.id} className="product-card">
                    <img
                      className="product-image"
                      src={product.image}
                      alt={product.name}
                    />
                    <div className="product-info">
                      <h3>{product.name}</h3>
                      <p>{product.description}</p>
                      <button className="add-to-cart-btn">Añadir al carrito</button>
                    </div>
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default FeaturedProductsCarousel;
